let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jFGnw")).then(() => parcelRequire('95xtc'));